<template>
	<div class="p-x-20 p-y-20 bg-white" @click="action">
		<div class="d-flex">
			<div class="d-flex justify-content-start align-items-center">
				<img
					v-if="iconFavorite"
					src="../../../assets/icons/star-filled.svg" alt="">
				<img
					v-if="iconTrash && !isTrashRed"
					src="../../../assets/icons/trash-2.svg" alt="">
				<img
					v-if="iconTrash && isTrashRed"
					src="../../../assets/icons/trash-red-big.svg" alt="">
				<img
					v-if="iconQr"
					src="../../../assets/icons/qrcode.svg" alt="">
				<img
					v-if="iconEdit"
					src="../../../assets/icons/edit-24.svg" alt="">
				<img
					v-if="iconHistory"
					src="../../../assets/icons/history.svg" alt="">
				<img
					v-if="iconPlus"
					src="../../../assets/icons/circle-plus-filled.svg" alt="">
			</div>
			<div class="d-block p-l-20">
				<div class="f-bold f-16">
					{{ title }}
				</div>
				<div class="f-regular f-14 f-c-midgrey" v-if="showSubtitle">
					{{ subtitle }}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "SOMenuItemIcon",
	props: {
		title: String,
		subtitle: String,
		showSubtitle: Boolean,

		// icon
		iconFavorite: Boolean,
		iconTrash: Boolean,
		iconQr: Boolean,
		iconEdit: Boolean,
		iconHistory: Boolean,
		iconPlus: Boolean,

		isTrashRed: Boolean
	},
	methods: {
		action(payload) {
			this.$emit("action", payload)
		}
	}
}
</script>